var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"switch"},[(_vm.label)?_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('div',{staticClass:"element",class:{'active': _vm.value === true},on:{"click":function($event){$event.preventDefault();return _vm.$emit('input', !_vm.value)}}},[_c('div',{staticClass:"indicator"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }